@if (canSwitch()) {
  <button
    type="button"
    class="sui-badge sui-badge-round text-xs"
    [suiDropdown]="tenantMenu"
    suiDropdownAlign="end"
    aria-haspopup="true"
    [attr.aria-label]="'Current tenant: ' + activeTenant().displayName + '. Switch tenant'"
    [suiTooltip]="'Switch tenant'"
  >
    <i class="sui-icon sui-icon-identification-badge"></i>
    <span class="hidden lg:inline truncate max-w-40">{{ activeTenant().displayName }}</span>
    <i class="sui-icon sui-icon-caret-down"></i>
  </button>

  <ng-template #tenantMenu>
    <ul class="sui-menu sui-menu-sm w-56" role="group" aria-label="Switch tenant">
      <li class="sui-menu-title">Tenant</li>
      @for (tenant of tenants(); track tenant.tenantShortName) {
        @let isActive = tenant.tenantShortName === activeTenant().tenantShortName;
        <li>
          <button
            type="button"
            [class.sui-menu-active]="isActive"
            [attr.aria-current]="isActive ? 'true' : null"
            (click)="onSelect(tenant)"
          >
            <i class="sui-icon" [class.sui-icon-check]="isActive" [class.sui-icon-identification-badge]="!isActive"></i>
            <span class="truncate">{{ tenant.displayName }}</span>
          </button>
        </li>
      }
    </ul>
  </ng-template>
} @else {
  <span
    class="sui-badge sui-badge-round text-xs"
    [suiTooltip]="'Current tenant'"
    [attr.aria-label]="'Current tenant: ' + activeTenant().displayName"
  >
    <i class="sui-icon sui-icon-identification-badge"></i>
    <span class="hidden lg:inline truncate max-w-40">{{ activeTenant().displayName }}</span>
  </span>
}
